module.exports = __webpack_public_path__ + "img/file-attachment-02.cec41d54.svg";